import styled, { css } from "styled-components";

export const TooltipGlowDefaultBox = styled.div<{bottom?: boolean}>`
  position: absolute;

  ${({bottom}) => bottom ? css`
      bottom: 0;
      right: 20px;
      background-position-y: 8px;
  ` : css`
      top: 0;
      left: 20px;
      background-position-y: -8px;
  `}

  width: 90px;
  height: 16px;

  background-image: ${props => `radial-gradient(closest-side at 50% 50%,${props.theme.colors.brandPrimary}C0 0%, ${props.theme.colors.brandPrimary}60 50%, ${props.theme.colors.brandPrimary}00 100%)`};
  background-repeat: no-repeat;
`;
